import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import cachios from 'cachios'
import { List } from 'react-content-loader'
import Slider from "react-slick";
import grey from '../assets/homeevent.jpeg'
import research from '../assets/research.jpg'
import pubreport from '../assets/pubreport.pdf'
import pubimg from '../assets/pubreport.jpg'

class HomeBooks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            langeng: localStorage.getItem('lang') ? false : true
        }
    }
    componentWillMount() {
        //EVENTS
        cachios.get(BASE + 'jsonapi/node/submit_for_work?include=field_image&filter[cis][condition][path]=field_cis_publications&filter[cis][condition][value]=1&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Books&page[limit]=8&page[offset]=0', {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                this.setState({
                    event: data.data.data,
                    included:data.data.included
                })
                let i, sarray = []
                for (i = 0; i < this.state.event.length; i++) {
                    sarray.push(this.state.event[i].attributes.drupal_internal__nid)
                }
                localStorage.setItem('sarray', JSON.stringify(sarray))
                console.log('homebook', this.state.event)
            })
            .catch((err) => {
                console.log('not found')
            })
    }

    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 3,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false
        };

        return (
            <div className="newhomebook">
                <div className="headertopdiv"></div>
                <div className="newhomebookdiv">
                    <div style={{ marginBottom: 0 }} className="row">
                        <div className="neweventsec col s8 m8 l8">
                            <div className="newhometitle">
                                <Link to='/cis_publication'>{this.props.isArabic == true ? 'كتب' : 'Publications'}</Link>
                            </div>
                            <div className='row workpaper_home' >
                                <div className='col s6 m6 l6' style={{ height: '600px !important' }}>
                                    <Slider {...settings} >
                                    {this.state.event ?<div className="views-field views-field-nothing homeevents">
                                            <div className="displ" style={{ borderBottom: 'none' }}>
                                                <div className="displimg">
                                                    <a target='_blank' href={pubreport}>
                                                        <img src={pubimg} />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>:""}
                                        {this.state.event ?<div className="views-field views-field-nothing homeevents">
                                            <div className="displ" style={{ borderBottom: 'none' }}>
                                                <div className="displimg">
                                                    <a target='_blank' href="https://www.cilecenter.org/tags/lamha">
                                                        <img src={research} />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>:""}
                                        {this.state.event ?
                                            this.state.event.map((event, index) => {
                                                let get = [],img=[]
                                                if (this.state.included) {
                                                    img = this.state.included
                                                    if (event.relationships.field_image.data) {
                                                         get = img.filter(x => x.id === event.relationships.field_image.data.id) 
                                                            console.log("get book image",get)
                                                        }
                                                }
                                                return (
                                                    <div className="views-field views-field-nothing homeevents">
                                                        <div className="displ" style={{ borderBottom: 'none' }}>
                                                            <div className="displimg">
                                                                <Link to={{ pathname: '/cis_publication/' + `${event.attributes.drupal_internal__nid}` }}>
                                                                    <img src={get[0] ? BASE + get[0].attributes.uri.url : grey} />
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            )
                                            : <List />}
                                    </Slider>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default HomeBooks;